export default __webpack_public_path__ + "images/assets/736d647bbd123c94ffda9f569c741c4a.svg";